import { render, staticRenderFns } from "./bkxx.vue?vue&type=template&id=6e17317b&scoped=true&"
import script from "./bkxx.vue?vue&type=script&lang=js&"
export * from "./bkxx.vue?vue&type=script&lang=js&"
import style0 from "./bkxx.vue?vue&type=style&index=0&id=6e17317b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17317b",
  null
  
)

export default component.exports